import { Navigate } from "react-router-dom";
import { checkUserHasAdminRole } from "app/services/app.state.service";
import { AdminResetPasswordView } from "app/components/adminResetPassword/AdminResetPasswordView";

/**
 * Route factory for the ADMIN-only "Reset Password for User" screen.
 * Non-admins are redirected to login via the SPA router (backend also enforces ADMIN
 * on the endpoint). This is client-side UX only — the real guard is server-side.
 */
export const AdminResetPasswordRouterFactory = () => {
  if (!checkUserHasAdminRole()) {
    return <Navigate to="/login" replace />;
  }
  return <AdminResetPasswordView />;
};
